function removeStartingZero(value: number | string) {
	const string = value.toString();

	if (string.charAt(0) == '0' && string.charAt(1) && string.charAt(1) != '.') {
		return removeStartingZero(string.slice(1));
	} else {
		return string;
	}
}

export default removeStartingZero;
